import React, { FunctionComponent, useRef, useState } from 'react'
import styled from 'styled-components'

import { defaultTheme as theme } from '../../theme'

const NewsletterWrapper = styled.form<{
  newsletterPage?: boolean
  communityPage?: boolean
}>`
display: flex;
align-items: center;
margin-top: 1.5rem;
min-width: 100%;
gap: 16px;
margin-bottom: 16px;
justify-content: space-between;
align-items: flex-start;
flex-direction: column;
@media (min-width: 768px) {
  flex-direction: ${(props) => (props.newsletterPage ? 'column' : 'row')};
  margin-bottom: 0;
  align-items: center;
}
@media (min-width: 1024px) {
  min-width: 500px;
}
.label-wrapper {
  gap: 16px;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  max-width: 100%;
  @media (min-width: 768px) {
    flex-direction: row;
  }
}
.input-name,
.input-email {
  gap: 16px;
  height: 48px;
  display: flex;
  background: white;
  padding: 14px 14px 14px 26px;
  border: 1px solid ${props => props.theme.colors.gray[300]};
  max-width: 100%;
  color: ${props => props.theme.colors.gray[600]};
  border-radius: 10px;
  display: flex;
  align-items: center;
  > input {
    font-size: 18px;
    background: transparent;
    border: none;
    width: 100%;
    outline: none;
    padding: 0;
    font-weight: 400;
    line-height: 20px;
    &:focus {
      border: none;
    }
  }
  @media (min-width: 768px) {
    width: 50%;
  }
  .leading-icon {
    height: 18px;
    width: 18px;
    svg {
      width: 100%;
      height: 100%;
      display: block;
      color: black;
    }
  }
}
a {
  height: 48px;
  > input {
    background: transparent;
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 110%;
    border: none;
    padding: 0;
    color: white;
  }
}
`

const icon = (name: string) => (
  <svg
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    width={24}
    height={24}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <use xlinkHref={`/feather-icons.svg#${name}`} />
  </svg>
)

const Button = styled.a<{ color?: string; type?: string }>`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-sizing: border-box;
  border-radius: 6px;
  text-decoration: none;
  border-color: ${(props) =>
    props.type === 'secondary'
      ? props.color === 'teal'
        ? theme.colors.teal[600]
        : theme.colors.indigo[600]
      : 'none'};
  ${(props) =>
    props.type === 'secondary' &&
    `
    border-width: 2px;
    border-style: solid;
  `}
  cursor: pointer;
  line-height: 1;
  transition: background-color 0.1s ease, color 0.2s ease;
  font-family: ${theme.fonts.text};
  font-weight: 500;
  font-size: 18px;
  background-color: ${(props) =>
    props.type === 'secondary'
      ? 'white'
      : props.color === 'teal'
      ? theme.colors.teal[600]
      : theme.colors.indigo[600]};
  color: ${(props) =>
    props.type === 'secondary'
      ? props.color === 'teal'
        ? theme.colors.teal[600]
        : theme.colors.indigo[600]
      : theme.colors.white};
  padding: 14px 28px;
  font-weight: bold;
  cursor: pointer;
  &:hover {
    background-color: ${(props) =>
      props.type === 'secondary'
        ? 'none'
        : props.color === 'teal'
        ? theme.colors.teal[700]
        : theme.colors.indigo[700]};
    ${(props) =>
      props.type === 'secondary' &&
      `
      color: ${
        props.color === 'teal' ? theme.colors.teal[700] : theme.colors.indigo[700]
      };
      border-color: ${
        props.color === 'teal' ? theme.colors.teal[700] : theme.colors.indigo[700]
      };
    `}
  }
  > input {
    cursor: pointer;
  }
`
const Newsletter: FunctionComponent<{
  placeholder?: string
}> = ({ placeholder = '' }) => {
  const [email, setEmail] = useState<string>('')
  const [name, setName] = useState<string>('')
  const [submitted, setSubmitted] = useState<boolean>(false)
  const mailchimpForm = useRef(null)
  const setFormSubmitted = () => {
    setName('')
    setEmail('')
    if(setSubmitted) setSubmitted(true)
  }
  return (
    <>
      <NewsletterWrapper
        action="https://prisma.us14.list-manage.com/subscribe/post-json"
        method="POST"
        target="hiddenFrame"
        ref={mailchimpForm}
        onSubmit={setFormSubmitted}
      >
        <input type="hidden" name="u" value="dbacf466dc6e90901d8936391" />
        <input type="hidden" name="id" value="83e066a034" />
        <input type="hidden" name="c" value="?" />
        <div className="label-wrapper">
          <label className="input-name" htmlFor="user-name">
            <div className="leading-icon">{icon('user')}</div>
            <input
              type="text"
              className="input-el"
              name="FNAME"
              id="user-name"
              placeholder="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </label>
          <label className="input-email" htmlFor="user-email">
            <div className="leading-icon">{icon('mail')}</div>
            <input
              type="email"
              className="input-el"
              name="EMAIL"
              id="user-email"
              value={email}
              placeholder="Email Address"
              onChange={(e) => setEmail(e.target.value)}
              autoCapitalize="off"
              autoCorrect="off"
            />
          </label>
        </div>
        <Button type="primary">
          <input
            type="submit"
            value={
              submitted ? 'Thank you!' : placeholder ? placeholder : 'Subscribe'
            }
            name="subscribe"
            id="subscribe-btn"
            className="button"
          />
        </Button>
      </NewsletterWrapper>
      <iframe
        name="hiddenFrame"
        src="about:blank"
        style={{ display: 'none' }}
      ></iframe>
    </>
  )
}

export default Newsletter
